enum ParagraphColor {
  info = "#8eff8e",
  danger = "#ff8e8e",
}

const applyStyle = (type, style, id?) => {
  const styleId = `dynamic-style-${type}${id ? `-${id}` : ""}`;
  let existingStyle = document.getElementById(styleId);

  if (existingStyle) {
    existingStyle.remove();
  }

  existingStyle = document.createElement("style");
  existingStyle.id = styleId;
  existingStyle.className = `dynamic-style-${type}`;
  existingStyle.innerHTML = style;
  document.head.appendChild(existingStyle);
};

export function removeStyles(type) {
  const styles = document.querySelectorAll(`.dynamic-style-${type}`);
  styles.forEach((style) => {
    style.remove();
  });
}

export function applyStyleToVariable(id) {
  const style = `
    variable[data-id="${id}"],
    variable[data-id="${id}"] ol,
    .variable-node[data-id="${id}"],
    .variable-node[data-id="${id}"] ol {
      background-color: yellow !important;
    }
  `;
  applyStyle("variable", style, id);
}

export function highlightCurrentVariable(currentEditingId = null) {
  // Remove all existing variable highlights first
  removeStyles("filled-variables");

  // Only highlight the currently editing variable, nothing else
  if (currentEditingId) {
    const style = `
      .ProseMirror variable[data-id="${currentEditingId}"],
      .ProseMirror variable[data-id="${currentEditingId}"] ol,
      .ProseMirror variable[data-id="${currentEditingId}"] ul,
      .ProseMirror .variable-node[data-id="${currentEditingId}"],
      .ProseMirror variable.variable-node[data-id="${currentEditingId}"],
      #editor variable[data-id="${currentEditingId}"],
      #content variable[data-id="${currentEditingId}"] {
        background-color: yellow !important;
        padding: 2px 4px !important;
        border-radius: 2px !important;
      }
    `;

    applyStyle("filled-variables", style);
  }
}

// For backward compatibility, keep the old name as an alias
export const highlightAllFilledVariables = highlightCurrentVariable;

export function applyStyleToParagraph(id, type) {
  const style = `
    .editor-container p[data-id="${id}"] {
      background-color: ${ParagraphColor[type]} !important;
    }
  `;
  applyStyle("paragraph", style, id);
}
